<ion-header class="ion-no-border">
    <ion-toolbar>
        <ion-title>Schedule a Ride</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="close()">
                <ion-icon name="close-outline" slot="icon-only"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <div class="schedule-container">
        <div class="info-text">
            <p>Select a date and time for your trip. We'll find a driver for you shortly before your scheduled
                departure.</p>
        </div>

        <ion-datetime [(ngModel)]="selectedDateTime" [min]="minDate" [max]="maxDate" presentation="date-time"
            size="cover" class="custom-datetime"></ion-datetime>

        <div class="footer-actions">
            <ion-button expand="block" shape="round" (click)="confirm()">
                Set Schedule
            </ion-button>
        </div>
    </div>
</ion-content>